// extracted by mini-css-extract-plugin
export default {"subcategoryList":"zqd4v","subcategoryIcon":"HkF+6","link":"s-JzC","labelWrapper":"CyJDd","label":"VmL3M","newPostIndicator":"NrEcI"};